// Auto-generated by LANCommander.CompletionGenerator — do not edit manually

export interface CmdletParameter {
    name: string;
    type: string;
    mandatory: boolean;
    position: number | null;
    helpMessage: string | null;
    aliases: string[];
}

export interface CmdletDefinition {
    name: string;
    description: string | null;
    outputType: string | null;
    parameters: CmdletParameter[];
}

export const cmdlets: CmdletDefinition[] = [
    {
        name: "Connect-SteamCmd",
        description: null,
        outputType: "SteamCmdStatus",
        parameters: [
            {
                name: "Username",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: "The Steam account username to log in with.",
                aliases: [],
            },
            {
                name: "Password",
                type: "SecureString",
                mandatory: false,
                position: null,
                helpMessage: "The password for the Steam account. If omitted, an anonymous login is attempted.",
                aliases: [],
            },
        ],
    },
    {
        name: "Convert-AspectRatio",
        description: null,
        outputType: "DisplayResolution",
        parameters: [
            {
                name: "Width",
                type: "int",
                mandatory: true,
                position: 0,
                helpMessage: "The base display width in pixels.",
                aliases: [],
            },
            {
                name: "Height",
                type: "int",
                mandatory: true,
                position: 1,
                helpMessage: "The base display height in pixels.",
                aliases: [],
            },
            {
                name: "AspectRatio",
                type: "double",
                mandatory: true,
                position: 2,
                helpMessage: "The target aspect ratio as a decimal (e.g. 1.7778 for 16:9).",
                aliases: [],
            },
        ],
    },
    {
        name: "ConvertFrom-SerializedBase64",
        description: null,
        outputType: "object",
        parameters: [
            {
                name: "Input",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: "A Base64-encoded string containing YAML-serialized data to deserialize.",
                aliases: [],
            },
        ],
    },
    {
        name: "ConvertTo-SerializedBase64",
        description: null,
        outputType: "string",
        parameters: [
            {
                name: "Input",
                type: "object",
                mandatory: true,
                position: 0,
                helpMessage: "The object to serialize to YAML and encode as a Base64 string.",
                aliases: [],
            },
        ],
    },
    {
        name: "ConvertTo-StringBytes",
        description: null,
        outputType: "byte[]",
        parameters: [
            {
                name: "Input",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: "The string to convert to a byte array.",
                aliases: [],
            },
            {
                name: "BigEndian",
                type: "bool",
                mandatory: false,
                position: null,
                helpMessage: "Use big-endian byte order for UTF-16 encoding. Only applies when -Utf16 is set.",
                aliases: [],
            },
            {
                name: "MaxLength",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: "Maximum number of characters to include. The string will be truncated if longer. Set to 0 for no limit.",
                aliases: [],
            },
            {
                name: "MinLength",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: "Minimum number of characters in the output. The string will be right-padded with null characters if shorter. Set to 0 for no padding.",
                aliases: [],
            },
            {
                name: "Utf16",
                type: "bool",
                mandatory: false,
                position: null,
                helpMessage: "Encode as UTF-16 instead of ASCII. Use with -BigEndian for big-endian UTF-16.",
                aliases: [],
            },
        ],
    },
    {
        name: "Disconnect-SteamCmd",
        description: null,
        outputType: "SteamCmdStatus",
        parameters: [
            {
                name: "Username",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: "The Steam account username to log out.",
                aliases: [],
            },
        ],
    },
    {
        name: "Edit-PatchBinary",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Offset",
                type: "long",
                mandatory: true,
                position: 0,
                helpMessage: "The byte offset within the file where the data should be written.",
                aliases: [],
            },
            {
                name: "Data",
                type: "byte[]",
                mandatory: true,
                position: 1,
                helpMessage: "The byte array to write at the specified offset.",
                aliases: [],
            },
            {
                name: "FilePath",
                type: "string",
                mandatory: true,
                position: 2,
                helpMessage: "The path to the binary file to patch.",
                aliases: ["f"],
            },
        ],
    },
    {
        name: "Edit-PatchGameSpy",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Path",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: "The root directory containing the game files to patch.",
                aliases: [],
            },
            {
                name: "Hostname",
                type: "string",
                mandatory: false,
                position: 1,
                helpMessage: "The replacement master server hostname. Must be exactly 12 characters. Defaults to \u0027openspy.net\u0027.",
                aliases: [],
            },
            {
                name: "PublicKey",
                type: "string",
                mandatory: false,
                position: 2,
                helpMessage: "The replacement public key for server authentication. Must match the original key length. Defaults to the OpenSpy public key.",
                aliases: [],
            },
            {
                name: "BinariesToPatch",
                type: "string[]",
                mandatory: false,
                position: 3,
                helpMessage: "Glob patterns for binary files to scan and patch. Defaults to \u0027*.dll\u0027, \u0027*.exe\u0027.",
                aliases: [],
            },
            {
                name: "TextFilesToPatch",
                type: "string[]",
                mandatory: false,
                position: 4,
                helpMessage: "Glob patterns for text files to scan and patch (e.g. Unreal Engine INI configs). Defaults to \u0027*.ini\u0027.",
                aliases: [],
            },
        ],
    },
    {
        name: "Expand-LatestArchive",
        description: null,
        outputType: "DirectoryInfo",
        parameters: [
            {
                name: "DestinationPath",
                type: "string",
                mandatory: false,
                position: 0,
                helpMessage: "The destination directory to extract the archive contents into. Defaults to the current working directory.",
                aliases: ["Destination", "OutputPath"],
            },
            {
                name: "GameId",
                type: "Guid?",
                mandatory: false,
                position: null,
                helpMessage: "The game ID to download. If not specified, uses the ID from the $GameManifest or $Game variable.",
                aliases: [],
            },
            {
                name: "RedistributableId",
                type: "Guid?",
                mandatory: false,
                position: null,
                helpMessage: "The redistributable ID to download. If not specified, uses the ID from the $Redistributable variable.",
                aliases: [],
            },
            {
                name: "ToolId",
                type: "Guid?",
                mandatory: false,
                position: null,
                helpMessage: "The tool ID to download. If not specified, uses the ID from the $Tool variable.",
                aliases: [],
            },
        ],
    },
    {
        name: "Get-GameManifest",
        description: null,
        outputType: "Game",
        parameters: [
            {
                name: "Path",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: "The directory path where the game manifest file is located.",
                aliases: [],
            },
            {
                name: "Id",
                type: "Guid",
                mandatory: true,
                position: null,
                helpMessage: "The unique identifier (GUID) of the game.",
                aliases: [],
            },
        ],
    },
    {
        name: "Get-HorizontalFov",
        description: null,
        outputType: "int",
        parameters: [
            {
                name: "BaseFov",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: "The base horizontal field of view in degrees at 4:3 aspect ratio. Defaults to 90.",
                aliases: [],
            },
            {
                name: "Height",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: "The display height in pixels. Defaults to the primary display height.",
                aliases: [],
            },
            {
                name: "Width",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: "The display width in pixels. Defaults to the primary display width.",
                aliases: [],
            },
        ],
    },
    {
        name: "Get-PrimaryDisplay",
        description: null,
        outputType: "Screen",
        parameters: [
        ],
    },
    {
        name: "Get-RedistributableOptions",
        description: null,
        outputType: "PSObject",
        parameters: [
            {
                name: "Path",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: "The install directory path where the game manifest is located.",
                aliases: [],
            },
            {
                name: "Id",
                type: "Guid",
                mandatory: true,
                position: null,
                helpMessage: "The unique identifier (GUID) of the game.",
                aliases: [],
            },
            {
                name: "Name",
                type: "string",
                mandatory: true,
                position: null,
                helpMessage: "The name of the redistributable to get options for.",
                aliases: [],
            },
        ],
    },
    {
        name: "Get-Runtime",
        description: null,
        outputType: "RuntimePlatform",
        parameters: [
        ],
    },
    {
        name: "Get-SanitizedPath",
        description: null,
        outputType: "string",
        parameters: [
            {
                name: "Path",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: "The path to sanitize.",
                aliases: [],
            },
        ],
    },
    {
        name: "Get-SteamAppInfo",
        description: null,
        outputType: "AppInfo",
        parameters: [
            {
                name: "AppId",
                type: "uint",
                mandatory: true,
                position: 0,
                helpMessage: "The Steam application ID to retrieve information for.",
                aliases: [],
            },
        ],
    },
    {
        name: "Get-SteamCmdConnectionStatus",
        description: null,
        outputType: "SteamCmdConnectionStatus",
        parameters: [
            {
                name: "Username",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: "The Steam account username to check the connection status for.",
                aliases: [],
            },
        ],
    },
    {
        name: "Get-SteamCmdPath",
        description: null,
        outputType: "string",
        parameters: [
        ],
    },
    {
        name: "Get-SteamCmdProfile",
        description: null,
        outputType: "SteamCmdProfile",
        parameters: [
            {
                name: "Username",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: "The Steam account username to retrieve the profile for.",
                aliases: [],
            },
        ],
    },
    {
        name: "Get-SteamCmdProfiles",
        description: null,
        outputType: "SteamCmdProfile",
        parameters: [
        ],
    },
    {
        name: "Get-SteamWebAssetUri",
        description: null,
        outputType: "Uri",
        parameters: [
            {
                name: "AppId",
                type: "int",
                mandatory: true,
                position: 0,
                helpMessage: "The Steam application ID.",
                aliases: [],
            },
            {
                name: "WebAssetType",
                type: "WebAssetType",
                mandatory: true,
                position: 1,
                helpMessage: "The type of web asset to retrieve the URI for (e.g. icon, header, capsule artwork).",
                aliases: [],
            },
        ],
    },
    {
        name: "Get-UserCustomField",
        description: null,
        outputType: "string",
        parameters: [
            {
                name: "Name",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: "The name of the custom field to retrieve for the current user.",
                aliases: [],
            },
        ],
    },
    {
        name: "Get-VerticalFov",
        description: null,
        outputType: "int",
        parameters: [
            {
                name: "BaseFov",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: "The base vertical field of view in degrees at 4:3 aspect ratio. Defaults to 75.",
                aliases: [],
            },
            {
                name: "Height",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: "The display height in pixels. Defaults to the primary display height.",
                aliases: [],
            },
            {
                name: "Width",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: "The display width in pixels. Defaults to the primary display width.",
                aliases: [],
            },
        ],
    },
    {
        name: "Install-SteamContent",
        description: null,
        outputType: "SteamCmdInstallJob",
        parameters: [
            {
                name: "AppId",
                type: "uint",
                mandatory: true,
                position: 0,
                helpMessage: "The Steam application ID to install.",
                aliases: [],
            },
            {
                name: "InstallDirectory",
                type: "string",
                mandatory: true,
                position: 1,
                helpMessage: "The directory path where the content should be installed.",
                aliases: [],
            },
            {
                name: "Username",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: "The Steam account username to use for downloading. If omitted, the default or anonymous account is used.",
                aliases: [],
            },
        ],
    },
    {
        name: "New-Package",
        description: null,
        outputType: "Package",
        parameters: [
            {
                name: "Path",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: "Specifies the path to the directory containing the package contents to be archived.",
                aliases: ["p", "Directory"],
            },
            {
                name: "Version",
                type: "string",
                mandatory: true,
                position: 1,
                helpMessage: "Specifies the version number for this package.",
                aliases: ["v"],
            },
            {
                name: "Changelog",
                type: "string",
                mandatory: false,
                position: 2,
                helpMessage: "Specifies the changelog describing changes in this package version.",
                aliases: ["c", "Notes"],
            },
        ],
    },
    {
        name: "Out-PlayerAvatar",
        description: null,
        outputType: "byte[]",
        parameters: [
        ],
    },
    {
        name: "Remove-SteamCmdProfile",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Username",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: "The Steam account username whose profile should be deleted.",
                aliases: [],
            },
        ],
    },
    {
        name: "Remove-SteamContent",
        description: null,
        outputType: "SteamCmdStatus",
        parameters: [
            {
                name: "InstallDirectory",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: "The directory path of the installed Steam content to remove.",
                aliases: [],
            },
        ],
    },
    {
        name: "Search-SteamGames",
        description: null,
        outputType: "GameSearchResult",
        parameters: [
            {
                name: "Keyword",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: "The search term to look for in the Steam store.",
                aliases: [],
            },
        ],
    },
    {
        name: "Set-SteamCmdProfile",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Username",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: "The Steam account username for the profile.",
                aliases: [],
            },
            {
                name: "InstallDirectory",
                type: "string",
                mandatory: true,
                position: 1,
                helpMessage: "The default installation directory for this Steam profile.",
                aliases: [],
            },
        ],
    },
    {
        name: "Update-IniValue",
        description: null,
        outputType: "string",
        parameters: [
            {
                name: "Section",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: "Specifies the section in the INI file that contains the key to be updated.",
                aliases: ["s"],
            },
            {
                name: "Key",
                type: "string",
                mandatory: true,
                position: 1,
                helpMessage: "Specifies the key within the section whose value should be updated.",
                aliases: ["k"],
            },
            {
                name: "Value",
                type: "string",
                mandatory: true,
                position: 2,
                helpMessage: "Specifies the new value to assign to the provided key.",
                aliases: ["v"],
            },
            {
                name: "FilePath",
                type: "string",
                mandatory: true,
                position: 3,
                helpMessage: "Specifies the file path to the INI file that should be processed.",
                aliases: ["f"],
            },
            {
                name: "AlwaysAppend",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: "If set, a new key-value pair will always be appended, even if the key already exists.",
                aliases: ["append"],
            },
            {
                name: "Clear",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: "If set, all instances of the specified key in the section will be cleared.",
                aliases: [],
            },
            {
                name: "Codepage",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: "Specifies the encoding (codepage) for reading and writing the INI file (e.g., \u0027UTF8\u0027, \u0027Latin\u0027, \u0027ASCII\u0027, \u0027Unicode\u0027).",
                aliases: ["encoding", "enc"],
            },
            {
                name: "InsertIndex",
                type: "int?",
                mandatory: false,
                position: null,
                helpMessage: "Specifies the index position at which the new key-value pair should be inserted. If not provided, the key is added at the end.",
                aliases: ["insert"],
            },
            {
                name: "KeepKeyDuplicates",
                type: "bool",
                mandatory: false,
                position: null,
                helpMessage: "If true, duplicate keys are allowed within the section.",
                aliases: ["keepkey", "keydup"],
            },
            {
                name: "KeepSectionDuplicates",
                type: "bool",
                mandatory: false,
                position: null,
                helpMessage: "If true, duplicate sections in the INI file are allowed.",
                aliases: ["keepsec", "secdup"],
            },
            {
                name: "NoAdd",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: "If set, restricts the operation to updating existing keys only; no new key will be added.",
                aliases: ["update-only", "only-update"],
            },
            {
                name: "NoKeyDuplicates",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: "If set, duplicate keys in the section are prevented.",
                aliases: ["nokey", "nokeydup"],
            },
            {
                name: "NoSectionDuplicates",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: "If set, duplicate section names are not permitted in the INI file.",
                aliases: ["nosec", "nosecdup"],
            },
            {
                name: "OnlyRemove",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: "If set, the key(s) will only be removed from the section without updating or adding any value.",
                aliases: ["remove-only"],
            },
            {
                name: "UpdateOrAdd",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: "If set, the cmdlet will update an existing key or add a new one if it does not exist.",
                aliases: ["add"],
            },
            {
                name: "WrapValueInQuotes",
                type: "bool?",
                mandatory: false,
                position: null,
                helpMessage: "If set, controls whether the value will be wrapped in quotes. Nullable: if null, adds quotes if missing; if true, enforces quotes; if false, removes quotes.",
                aliases: ["wrap", "quotes"],
            },
        ],
    },
    {
        name: "Update-UserCustomField",
        description: null,
        outputType: "string",
        parameters: [
            {
                name: "Name",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: "The name of the custom field to update.",
                aliases: [],
            },
            {
                name: "Value",
                type: "string",
                mandatory: true,
                position: 1,
                helpMessage: "The new value to set for the custom field.",
                aliases: [],
            },
        ],
    },
    {
        name: "Write-GameManifest",
        description: null,
        outputType: "string",
        parameters: [
            {
                name: "Path",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: "The directory path where the game manifest file should be written.",
                aliases: [],
            },
            {
                name: "Manifest",
                type: "Game",
                mandatory: true,
                position: 1,
                helpMessage: "The game manifest object to serialize and write to disk.",
                aliases: [],
            },
        ],
    },
    {
        name: "Write-ReplaceContentInFile",
        description: null,
        outputType: "string",
        parameters: [
            {
                name: "Pattern",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: "The regular expression pattern to search for in the file content.",
                aliases: [],
            },
            {
                name: "Substitution",
                type: "string",
                mandatory: true,
                position: 1,
                helpMessage: "The replacement string. Supports regex substitution groups ($1, $2, etc.).",
                aliases: [],
            },
            {
                name: "FilePath",
                type: "string",
                mandatory: true,
                position: 2,
                helpMessage: "The path to the text file to modify.",
                aliases: ["f"],
            },
        ],
    },
];

export const builtinCmdlets: CmdletDefinition[] = [
    {
        name: "Add-Content",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Path",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Value",
                type: "object[]",
                mandatory: true,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "AsByteStream",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Credential",
                type: "PSCredential",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Encoding",
                type: "Encoding",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Exclude",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Filter",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Include",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
            {
                name: "NoNewline",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "PassThru",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Add-Member",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "MemberType",
                type: "PSMemberTypes",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: ["Type"],
            },
            {
                name: "NotePropertyMembers",
                type: "IDictionary",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "NotePropertyName",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Name",
                type: "string",
                mandatory: true,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "NotePropertyValue",
                type: "object",
                mandatory: true,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Value",
                type: "object",
                mandatory: false,
                position: 2,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "SecondValue",
                type: "object",
                mandatory: false,
                position: 3,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "InputObject",
                type: "object",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "PassThru",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "TypeName",
                type: "string",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Add-Type",
        description: null,
        outputType: "Type",
        parameters: [
            {
                name: "Name",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Path",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "TypeDefinition",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "MemberDefinition",
                type: "string[]",
                mandatory: true,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "AssemblyName",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["AN"],
            },
            {
                name: "CompilerOptions",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "IgnoreWarnings",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Language",
                type: "Language",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
            {
                name: "Namespace",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["NS"],
            },
            {
                name: "OutputAssembly",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["OA"],
            },
            {
                name: "OutputType",
                type: "OutputAssemblyType",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["OT"],
            },
            {
                name: "PassThru",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "ReferencedAssemblies",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["RA"],
            },
            {
                name: "UsingNamespace",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["Using"],
            },
        ],
    },
    {
        name: "Clear-Content",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Path",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Credential",
                type: "PSCredential",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Exclude",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Filter",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Include",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
        ],
    },
    {
        name: "Clear-Item",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Path",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Credential",
                type: "PSCredential",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Exclude",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Filter",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Include",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
        ],
    },
    {
        name: "Clear-ItemProperty",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Path",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Name",
                type: "string",
                mandatory: true,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Credential",
                type: "PSCredential",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Exclude",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Filter",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Include",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
            {
                name: "PassThru",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Clear-Variable",
        description: null,
        outputType: "PSVariable",
        parameters: [
            {
                name: "Name",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Exclude",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Include",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "PassThru",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Scope",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Compare-Object",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "ReferenceObject",
                type: "object[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "DifferenceObject",
                type: "object[]",
                mandatory: true,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "CaseSensitive",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Culture",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "ExcludeDifferent",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "IncludeEqual",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "PassThru",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Property",
                type: "object[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "SyncWindow",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Compress-Archive",
        description: null,
        outputType: "File",
        parameters: [
            {
                name: "Path",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "DestinationPath",
                type: "string",
                mandatory: true,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "CompressionLevel",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath"],
            },
            {
                name: "PassThru",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Update",
                type: "SwitchParameter",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Convert-Path",
        description: null,
        outputType: "string",
        parameters: [
            {
                name: "Path",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
        ],
    },
    {
        name: "ConvertFrom-CliXml",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "InputObject",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "ConvertFrom-Csv",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "InputObject",
                type: "object[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Delimiter",
                type: "Char",
                mandatory: false,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Header",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "UseCulture",
                type: "SwitchParameter",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "ConvertFrom-Json",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "InputObject",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "AsHashtable",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "DateKind",
                type: "JsonDateKind",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Depth",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "NoEnumerate",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "ConvertFrom-Markdown",
        description: null,
        outputType: "MarkdownInfo",
        parameters: [
            {
                name: "Path",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "AsVT100EncodedString",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "InputObject",
                type: "object",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
        ],
    },
    {
        name: "ConvertFrom-SecureString",
        description: null,
        outputType: "string",
        parameters: [
            {
                name: "SecureString",
                type: "SecureString",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "SecureKey",
                type: "SecureString",
                mandatory: false,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "AsPlainText",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Key",
                type: "byte[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "ConvertFrom-StringData",
        description: null,
        outputType: "Hashtable",
        parameters: [
            {
                name: "StringData",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Delimiter",
                type: "Char",
                mandatory: false,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "ConvertTo-CliXml",
        description: null,
        outputType: "string",
        parameters: [
            {
                name: "InputObject",
                type: "object",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Depth",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "ConvertTo-Csv",
        description: null,
        outputType: "string",
        parameters: [
            {
                name: "InputObject",
                type: "object",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Delimiter",
                type: "Char",
                mandatory: false,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "IncludeTypeInformation",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["ITI"],
            },
            {
                name: "NoHeader",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "NoTypeInformation",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["NTI"],
            },
            {
                name: "QuoteFields",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["QF"],
            },
            {
                name: "UseCulture",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "UseQuotes",
                type: "QuoteKind",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["UQ"],
            },
        ],
    },
    {
        name: "ConvertTo-Html",
        description: null,
        outputType: "string",
        parameters: [
            {
                name: "Property",
                type: "object[]",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Head",
                type: "string[]",
                mandatory: false,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Title",
                type: "string",
                mandatory: false,
                position: 2,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Body",
                type: "string[]",
                mandatory: false,
                position: 3,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "As",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Charset",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "CssUri",
                type: "Uri",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["cu", "uri"],
            },
            {
                name: "Fragment",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "InputObject",
                type: "object",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Meta",
                type: "Hashtable",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "PostContent",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "PreContent",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Transitional",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "ConvertTo-Json",
        description: null,
        outputType: "string",
        parameters: [
            {
                name: "InputObject",
                type: "object",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "AsArray",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Compress",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Depth",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "EnumsAsStrings",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "EscapeHandling",
                type: "StringEscapeHandling",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "ConvertTo-SecureString",
        description: null,
        outputType: "SecureString",
        parameters: [
            {
                name: "String",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "AsPlainText",
                type: "SwitchParameter",
                mandatory: false,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "SecureKey",
                type: "SecureString",
                mandatory: false,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: 2,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Key",
                type: "byte[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "ConvertTo-Xml",
        description: null,
        outputType: "XmlDocument",
        parameters: [
            {
                name: "InputObject",
                type: "object",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "As",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Depth",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: "Specifies how many levels of contained objects should be included in the XML representation",
                aliases: [],
            },
            {
                name: "NoTypeInformation",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: "Specifies not to include the Type information in the XML representation",
                aliases: [],
            },
        ],
    },
    {
        name: "Copy-Item",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Path",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Destination",
                type: "string",
                mandatory: false,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Container",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Credential",
                type: "PSCredential",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Exclude",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Filter",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "FromSession",
                type: "PSSession",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Include",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
            {
                name: "PassThru",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Recurse",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "ToSession",
                type: "PSSession",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Copy-ItemProperty",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Path",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Destination",
                type: "string",
                mandatory: true,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Name",
                type: "string",
                mandatory: true,
                position: 2,
                helpMessage: null,
                aliases: ["PSProperty"],
            },
            {
                name: "Credential",
                type: "PSCredential",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Exclude",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Filter",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Include",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
            {
                name: "PassThru",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Debug-Process",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Id",
                type: "int[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: ["PID", "ProcessId"],
            },
            {
                name: "Name",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: ["ProcessName"],
            },
            {
                name: "InputObject",
                type: "Process[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Debug-Runspace",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Id",
                type: "int",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "InstanceId",
                type: "Guid",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Name",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Runspace",
                type: "Runspace",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "BreakAll",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Disable-PSBreakpoint",
        description: null,
        outputType: "Breakpoint",
        parameters: [
            {
                name: "Breakpoint",
                type: "Breakpoint[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Id",
                type: "int[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "PassThru",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Runspace",
                type: "Runspace",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["RunspaceId"],
            },
        ],
    },
    {
        name: "Disable-RunspaceDebug",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "ProcessName",
                type: "string",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Runspace",
                type: "Runspace[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "RunspaceId",
                type: "int[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "RunspaceInstanceId",
                type: "Guid[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "RunspaceName",
                type: "string[]",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "AppDomainName",
                type: "string[]",
                mandatory: false,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Enable-PSBreakpoint",
        description: null,
        outputType: "Breakpoint",
        parameters: [
            {
                name: "Breakpoint",
                type: "Breakpoint[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Id",
                type: "int[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "PassThru",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Runspace",
                type: "Runspace",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["RunspaceId"],
            },
        ],
    },
    {
        name: "Enable-RunspaceDebug",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "ProcessName",
                type: "string",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Runspace",
                type: "Runspace[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "RunspaceId",
                type: "int[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "RunspaceInstanceId",
                type: "Guid[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "RunspaceName",
                type: "string[]",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "AppDomainName",
                type: "string[]",
                mandatory: false,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "BreakAll",
                type: "SwitchParameter",
                mandatory: false,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Expand-Archive",
        description: null,
        outputType: "FileSystemInfo",
        parameters: [
            {
                name: "Path",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "DestinationPath",
                type: "string",
                mandatory: false,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath"],
            },
            {
                name: "PassThru",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Export-Alias",
        description: null,
        outputType: "AliasInfo",
        parameters: [
            {
                name: "Path",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Name",
                type: "string[]",
                mandatory: false,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Append",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "As",
                type: "ExportAliasFormat",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Description",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
            {
                name: "NoClobber",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["NoOverwrite"],
            },
            {
                name: "PassThru",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Scope",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Export-Clixml",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Path",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Depth",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Encoding",
                type: "Encoding",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "InputObject",
                type: "object",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
            {
                name: "NoClobber",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["NoOverwrite"],
            },
        ],
    },
    {
        name: "Export-Csv",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Path",
                type: "string",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Delimiter",
                type: "Char",
                mandatory: false,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Append",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Encoding",
                type: "Encoding",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "IncludeTypeInformation",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["ITI"],
            },
            {
                name: "InputObject",
                type: "object",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
            {
                name: "NoClobber",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["NoOverwrite"],
            },
            {
                name: "NoHeader",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "NoTypeInformation",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["NTI"],
            },
            {
                name: "QuoteFields",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["QF"],
            },
            {
                name: "UseCulture",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "UseQuotes",
                type: "QuoteKind",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["UQ"],
            },
        ],
    },
    {
        name: "Export-FormatData",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "IncludeScriptBlock",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "InputObject",
                type: "ExtendedTypeDefinition[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
            {
                name: "NoClobber",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["NoOverwrite"],
            },
            {
                name: "Path",
                type: "string",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["FilePath"],
            },
        ],
    },
    {
        name: "Export-PSSession",
        description: null,
        outputType: "FileInfo",
        parameters: [
            {
                name: "Session",
                type: "PSSession",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "OutputModule",
                type: "string",
                mandatory: true,
                position: 1,
                helpMessage: null,
                aliases: ["PSPath", "ModuleName"],
            },
            {
                name: "CommandName",
                type: "string[]",
                mandatory: false,
                position: 2,
                helpMessage: null,
                aliases: ["Name"],
            },
            {
                name: "FormatTypeName",
                type: "string[]",
                mandatory: false,
                position: 3,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "AllowClobber",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "ArgumentList",
                type: "object[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["Args"],
            },
            {
                name: "Certificate",
                type: "X509Certificate2",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "CommandType",
                type: "CommandTypes",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["Type"],
            },
            {
                name: "Encoding",
                type: "Encoding",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "FullyQualifiedModule",
                type: "ModuleSpecification[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Module",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["PSSnapin"],
            },
        ],
    },
    {
        name: "Format-Custom",
        description: null,
        outputType: "FormatStartData",
        parameters: [
            {
                name: "Property",
                type: "object[]",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Depth",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "DisplayError",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Expand",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "GroupBy",
                type: "object",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "InputObject",
                type: "object",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "ShowError",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "View",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Format-Hex",
        description: null,
        outputType: "ByteCollection",
        parameters: [
            {
                name: "Path",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Count",
                type: "long",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Encoding",
                type: "Encoding",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "InputObject",
                type: "object",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
            {
                name: "Offset",
                type: "long",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Raw",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Format-List",
        description: null,
        outputType: "FormatStartData",
        parameters: [
            {
                name: "Property",
                type: "object[]",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "DisplayError",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Expand",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "GroupBy",
                type: "object",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "InputObject",
                type: "object",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "ShowError",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "View",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Format-Table",
        description: null,
        outputType: "FormatStartData",
        parameters: [
            {
                name: "Property",
                type: "object[]",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "AutoSize",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "DisplayError",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Expand",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "GroupBy",
                type: "object",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "HideTableHeaders",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "InputObject",
                type: "object",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "RepeatHeader",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "ShowError",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "View",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Wrap",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Format-Wide",
        description: null,
        outputType: "FormatStartData",
        parameters: [
            {
                name: "Property",
                type: "object",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "AutoSize",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Column",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "DisplayError",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Expand",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "GroupBy",
                type: "object",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "InputObject",
                type: "object",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "ShowError",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "View",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Get-Alias",
        description: null,
        outputType: "AliasInfo",
        parameters: [
            {
                name: "Name",
                type: "string[]",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Definition",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Exclude",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Scope",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Get-ChildItem",
        description: null,
        outputType: "FileInfo",
        parameters: [
            {
                name: "Path",
                type: "string[]",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Filter",
                type: "string",
                mandatory: false,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Attributes",
                type: "FlagsExpression\u00601",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Depth",
                type: "uint",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Directory",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["ad"],
            },
            {
                name: "Exclude",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "File",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["af"],
            },
            {
                name: "FollowSymlink",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Hidden",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["ah", "h"],
            },
            {
                name: "Include",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
            {
                name: "Name",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "ReadOnly",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["ar"],
            },
            {
                name: "Recurse",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["s", "r"],
            },
            {
                name: "System",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["as"],
            },
        ],
    },
    {
        name: "Get-Clipboard",
        description: null,
        outputType: "string",
        parameters: [
            {
                name: "Delimiter",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Raw",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Get-CmsMessage",
        description: null,
        outputType: "EnvelopedCms",
        parameters: [
            {
                name: "Content",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string",
                mandatory: true,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Path",
                type: "string",
                mandatory: true,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Get-Content",
        description: null,
        outputType: "byte",
        parameters: [
            {
                name: "Path",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "AsByteStream",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Credential",
                type: "PSCredential",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Delimiter",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Encoding",
                type: "Encoding",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Exclude",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Filter",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Include",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
            {
                name: "Raw",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "ReadCount",
                type: "long",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Tail",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["Last"],
            },
            {
                name: "TotalCount",
                type: "long",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["First", "Head"],
            },
            {
                name: "Wait",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Get-Credential",
        description: null,
        outputType: "PSCredential",
        parameters: [
            {
                name: "Credential",
                type: "PSCredential",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "UserName",
                type: "string",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Message",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Title",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Get-Culture",
        description: null,
        outputType: "CultureInfo",
        parameters: [
            {
                name: "Name",
                type: "string[]",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "ListAvailable",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "NoUserOverrides",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Get-Date",
        description: null,
        outputType: "string",
        parameters: [
            {
                name: "Date",
                type: "DateTime",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: ["LastWriteTime"],
            },
            {
                name: "AsUTC",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Day",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "DisplayHint",
                type: "DisplayHintType",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Format",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Hour",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Millisecond",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Minute",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Month",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Second",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "UFormat",
                type: "string",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "UnixTimeSeconds",
                type: "long",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["UnixTime"],
            },
            {
                name: "Year",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Get-Error",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "InputObject",
                type: "object",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Newest",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["Last"],
            },
        ],
    },
    {
        name: "Get-Event",
        description: null,
        outputType: "PSEventArgs",
        parameters: [
            {
                name: "EventIdentifier",
                type: "int",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: ["Id"],
            },
            {
                name: "SourceIdentifier",
                type: "string",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Get-EventSubscriber",
        description: null,
        outputType: "PSEventSubscriber",
        parameters: [
            {
                name: "SourceIdentifier",
                type: "string",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "SubscriptionId",
                type: "int",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: ["Id"],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Get-ExecutionPolicy",
        description: null,
        outputType: "ExecutionPolicy",
        parameters: [
            {
                name: "Scope",
                type: "ExecutionPolicyScope",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "List",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Get-FileHash",
        description: null,
        outputType: "FileHashInfo",
        parameters: [
            {
                name: "InputStream",
                type: "Stream",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
            {
                name: "Path",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Algorithm",
                type: "string",
                mandatory: false,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Get-FormatData",
        description: null,
        outputType: "ExtendedTypeDefinition",
        parameters: [
            {
                name: "TypeName",
                type: "string[]",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "PowerShellVersion",
                type: "Version",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Get-Host",
        description: null,
        outputType: "PSHost",
        parameters: [
        ],
    },
    {
        name: "Get-Item",
        description: null,
        outputType: "FileInfo",
        parameters: [
            {
                name: "Path",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Credential",
                type: "PSCredential",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Exclude",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Filter",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Include",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
        ],
    },
    {
        name: "Get-ItemProperty",
        description: null,
        outputType: "bool",
        parameters: [
            {
                name: "Path",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Name",
                type: "string[]",
                mandatory: false,
                position: 1,
                helpMessage: null,
                aliases: ["PSProperty"],
            },
            {
                name: "Credential",
                type: "PSCredential",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Exclude",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Filter",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Include",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
        ],
    },
    {
        name: "Get-ItemPropertyValue",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Path",
                type: "string[]",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Name",
                type: "string[]",
                mandatory: true,
                position: 1,
                helpMessage: null,
                aliases: ["PSProperty"],
            },
            {
                name: "Credential",
                type: "PSCredential",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Exclude",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Filter",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Include",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
        ],
    },
    {
        name: "Get-Location",
        description: null,
        outputType: "PathInfo",
        parameters: [
            {
                name: "PSDrive",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "PSProvider",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Stack",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "StackName",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Get-MarkdownOption",
        description: null,
        outputType: "PSMarkdownOptionInfo",
        parameters: [
        ],
    },
    {
        name: "Get-Member",
        description: null,
        outputType: "MemberDefinition",
        parameters: [
            {
                name: "Name",
                type: "string[]",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "InputObject",
                type: "object",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "MemberType",
                type: "PSMemberTypes",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["Type"],
            },
            {
                name: "Static",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "View",
                type: "PSMemberViewTypes",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Get-PfxCertificate",
        description: null,
        outputType: "X509Certificate2",
        parameters: [
            {
                name: "FilePath",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
            {
                name: "NoPromptForPassword",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Password",
                type: "SecureString",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Get-Process",
        description: null,
        outputType: "ProcessModule",
        parameters: [
            {
                name: "Name",
                type: "string[]",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: ["ProcessName"],
            },
            {
                name: "FileVersionInfo",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["FV", "FVI"],
            },
            {
                name: "Id",
                type: "int[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PID"],
            },
            {
                name: "IncludeUserName",
                type: "SwitchParameter",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "InputObject",
                type: "Process[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Module",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Get-PSBreakpoint",
        description: null,
        outputType: "CommandBreakpoint",
        parameters: [
            {
                name: "Id",
                type: "int[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Script",
                type: "string[]",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Type",
                type: "BreakpointType[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Command",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Runspace",
                type: "Runspace",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Variable",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Get-PSCallStack",
        description: null,
        outputType: "CallStackFrame",
        parameters: [
        ],
    },
    {
        name: "Get-PSDrive",
        description: null,
        outputType: "PSDriveInfo",
        parameters: [
            {
                name: "LiteralName",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Name",
                type: "string[]",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "PSProvider",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Scope",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Get-PSProvider",
        description: null,
        outputType: "ProviderInfo",
        parameters: [
            {
                name: "PSProvider",
                type: "string[]",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Get-Random",
        description: null,
        outputType: "int",
        parameters: [
            {
                name: "InputObject",
                type: "object[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Maximum",
                type: "object",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Count",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Minimum",
                type: "object",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "SetSeed",
                type: "Nullable\u00601",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Shuffle",
                type: "SwitchParameter",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Get-Runspace",
        description: null,
        outputType: "Runspace",
        parameters: [
            {
                name: "Id",
                type: "int[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "InstanceId",
                type: "Guid[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Name",
                type: "string[]",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Get-RunspaceDebug",
        description: null,
        outputType: "PSRunspaceDebug",
        parameters: [
            {
                name: "ProcessName",
                type: "string",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Runspace",
                type: "Runspace[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "RunspaceId",
                type: "int[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "RunspaceInstanceId",
                type: "Guid[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "RunspaceName",
                type: "string[]",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "AppDomainName",
                type: "string[]",
                mandatory: false,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Get-SecureRandom",
        description: null,
        outputType: "int",
        parameters: [
            {
                name: "InputObject",
                type: "object[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Maximum",
                type: "object",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Count",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Minimum",
                type: "object",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Shuffle",
                type: "SwitchParameter",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Get-TimeZone",
        description: null,
        outputType: "TimeZoneInfo",
        parameters: [
            {
                name: "Name",
                type: "string[]",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Id",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "ListAvailable",
                type: "SwitchParameter",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Get-TraceSource",
        description: null,
        outputType: "PSTraceSource",
        parameters: [
            {
                name: "Name",
                type: "string[]",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Get-TypeData",
        description: null,
        outputType: "object",
        parameters: [
            {
                name: "TypeName",
                type: "string[]",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Get-UICulture",
        description: null,
        outputType: "CultureInfo",
        parameters: [
        ],
    },
    {
        name: "Get-Unique",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "AsString",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "CaseInsensitive",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "InputObject",
                type: "object",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "OnType",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Get-Uptime",
        description: null,
        outputType: "TimeSpan",
        parameters: [
            {
                name: "Since",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Get-Variable",
        description: null,
        outputType: "PSVariable",
        parameters: [
            {
                name: "Name",
                type: "string[]",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Exclude",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Include",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Scope",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "ValueOnly",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Get-Verb",
        description: null,
        outputType: "VerbInfo",
        parameters: [
            {
                name: "Verb",
                type: "string[]",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Group",
                type: "string[]",
                mandatory: false,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Group-Object",
        description: null,
        outputType: "Hashtable",
        parameters: [
            {
                name: "Property",
                type: "object[]",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "AsHashTable",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["AHT"],
            },
            {
                name: "AsString",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "CaseSensitive",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Culture",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "InputObject",
                type: "object",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "NoElement",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Import-Alias",
        description: null,
        outputType: "AliasInfo",
        parameters: [
            {
                name: "Path",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
            {
                name: "PassThru",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Scope",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Import-Clixml",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Path",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "First",
                type: "UInt64",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "IncludeTotalCount",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
            {
                name: "Skip",
                type: "UInt64",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Import-Csv",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Path",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Delimiter",
                type: "Char",
                mandatory: false,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Encoding",
                type: "Encoding",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Header",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
            {
                name: "UseCulture",
                type: "SwitchParameter",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Import-LocalizedData",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "BindingVariable",
                type: "string",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: ["Variable"],
            },
            {
                name: "UICulture",
                type: "string",
                mandatory: false,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "BaseDirectory",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "FileName",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "SupportedCommand",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Import-PowerShellDataFile",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "LiteralPath",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
            {
                name: "Path",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "SkipLimitCheck",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Import-PSSession",
        description: null,
        outputType: "PSModuleInfo",
        parameters: [
            {
                name: "Session",
                type: "PSSession",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "CommandName",
                type: "string[]",
                mandatory: false,
                position: 2,
                helpMessage: null,
                aliases: ["Name"],
            },
            {
                name: "FormatTypeName",
                type: "string[]",
                mandatory: false,
                position: 3,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "AllowClobber",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "ArgumentList",
                type: "object[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["Args"],
            },
            {
                name: "Certificate",
                type: "X509Certificate2",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "CommandType",
                type: "CommandTypes",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["Type"],
            },
            {
                name: "DisableNameChecking",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "FullyQualifiedModule",
                type: "ModuleSpecification[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Module",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["PSSnapin"],
            },
            {
                name: "Prefix",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Invoke-Expression",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Command",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Invoke-Item",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Path",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Credential",
                type: "PSCredential",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Exclude",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Filter",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Include",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
        ],
    },
    {
        name: "Invoke-RestMethod",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Uri",
                type: "Uri",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "AllowInsecureRedirect",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "AllowUnencryptedAuthentication",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Authentication",
                type: "WebAuthenticationType",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Body",
                type: "object",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Certificate",
                type: "X509Certificate",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "CertificateThumbprint",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "ConnectionTimeoutSeconds",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["TimeoutSec"],
            },
            {
                name: "ContentType",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Credential",
                type: "PSCredential",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "CustomMethod",
                type: "string",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["CM"],
            },
            {
                name: "DisableKeepAlive",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "FollowRelLink",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["FL"],
            },
            {
                name: "Form",
                type: "IDictionary",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Headers",
                type: "IDictionary",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "HttpVersion",
                type: "Version",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "InFile",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "MaximumFollowRelLink",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["ML"],
            },
            {
                name: "MaximumRedirection",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "MaximumRetryCount",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Method",
                type: "WebRequestMethod",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "NoProxy",
                type: "SwitchParameter",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "OperationTimeoutSeconds",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "OutFile",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "PassThru",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "PreserveAuthorizationOnRedirect",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "PreserveHttpMethodOnRedirect",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Proxy",
                type: "Uri",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "ProxyCredential",
                type: "PSCredential",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "ProxyUseDefaultCredentials",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "ResponseHeadersVariable",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["RHV"],
            },
            {
                name: "Resume",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "RetryIntervalSec",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "SessionVariable",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["SV"],
            },
            {
                name: "SkipCertificateCheck",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "SkipHeaderValidation",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "SkipHttpErrorCheck",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "SslProtocol",
                type: "WebSslProtocol",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "StatusCodeVariable",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Token",
                type: "SecureString",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "TransferEncoding",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "UnixSocket",
                type: "UnixDomainSocketEndPoint",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "UseBasicParsing",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "UseDefaultCredentials",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "UserAgent",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "WebSession",
                type: "WebRequestSession",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Invoke-WebRequest",
        description: null,
        outputType: "BasicHtmlWebResponseObject",
        parameters: [
            {
                name: "Uri",
                type: "Uri",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "AllowInsecureRedirect",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "AllowUnencryptedAuthentication",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Authentication",
                type: "WebAuthenticationType",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Body",
                type: "object",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Certificate",
                type: "X509Certificate",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "CertificateThumbprint",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "ConnectionTimeoutSeconds",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["TimeoutSec"],
            },
            {
                name: "ContentType",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Credential",
                type: "PSCredential",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "CustomMethod",
                type: "string",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["CM"],
            },
            {
                name: "DisableKeepAlive",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Form",
                type: "IDictionary",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Headers",
                type: "IDictionary",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "HttpVersion",
                type: "Version",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "InFile",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "MaximumRedirection",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "MaximumRetryCount",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Method",
                type: "WebRequestMethod",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "NoProxy",
                type: "SwitchParameter",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "OperationTimeoutSeconds",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "OutFile",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "PassThru",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "PreserveAuthorizationOnRedirect",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "PreserveHttpMethodOnRedirect",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Proxy",
                type: "Uri",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "ProxyCredential",
                type: "PSCredential",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "ProxyUseDefaultCredentials",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Resume",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "RetryIntervalSec",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "SessionVariable",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["SV"],
            },
            {
                name: "SkipCertificateCheck",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "SkipHeaderValidation",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "SkipHttpErrorCheck",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "SslProtocol",
                type: "WebSslProtocol",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Token",
                type: "SecureString",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "TransferEncoding",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "UnixSocket",
                type: "UnixDomainSocketEndPoint",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "UseBasicParsing",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "UseDefaultCredentials",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "UserAgent",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "WebSession",
                type: "WebRequestSession",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Join-Path",
        description: null,
        outputType: "string",
        parameters: [
            {
                name: "Path",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: ["PSPath"],
            },
            {
                name: "ChildPath",
                type: "string[]",
                mandatory: true,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "AdditionalChildPath",
                type: "string[]",
                mandatory: false,
                position: 2,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Credential",
                type: "PSCredential",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Resolve",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Join-String",
        description: null,
        outputType: "string",
        parameters: [
            {
                name: "Property",
                type: "PSPropertyExpression",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Separator",
                type: "string",
                mandatory: false,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "DoubleQuote",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "FormatString",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "InputObject",
                type: "object[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "OutputPrefix",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["op"],
            },
            {
                name: "OutputSuffix",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["os"],
            },
            {
                name: "SingleQuote",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "UseCulture",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Measure-Command",
        description: null,
        outputType: "TimeSpan",
        parameters: [
            {
                name: "Expression",
                type: "ScriptBlock",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "InputObject",
                type: "object",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Measure-Object",
        description: null,
        outputType: "GenericMeasureInfo",
        parameters: [
            {
                name: "Property",
                type: "PSPropertyExpression[]",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "AllStats",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Average",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Character",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "IgnoreWhiteSpace",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "InputObject",
                type: "object",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Line",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Maximum",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Minimum",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "StandardDeviation",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Sum",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Word",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Move-Item",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Path",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Destination",
                type: "string",
                mandatory: false,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Credential",
                type: "PSCredential",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Exclude",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Filter",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Include",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
            {
                name: "PassThru",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Move-ItemProperty",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Path",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Destination",
                type: "string",
                mandatory: true,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Name",
                type: "string[]",
                mandatory: true,
                position: 2,
                helpMessage: null,
                aliases: ["PSProperty"],
            },
            {
                name: "Credential",
                type: "PSCredential",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Exclude",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Filter",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Include",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
            {
                name: "PassThru",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "New-Alias",
        description: null,
        outputType: "AliasInfo",
        parameters: [
            {
                name: "Name",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Value",
                type: "string",
                mandatory: true,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Description",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Option",
                type: "ScopedItemOptions",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "PassThru",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Scope",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "New-Event",
        description: null,
        outputType: "PSEventArgs",
        parameters: [
            {
                name: "SourceIdentifier",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Sender",
                type: "object",
                mandatory: false,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "EventArguments",
                type: "object[]",
                mandatory: false,
                position: 2,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "MessageData",
                type: "object",
                mandatory: false,
                position: 3,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "New-Guid",
        description: null,
        outputType: "Guid",
        parameters: [
            {
                name: "InputObject",
                type: "string",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Empty",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "New-Item",
        description: null,
        outputType: "string",
        parameters: [
            {
                name: "Path",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Credential",
                type: "PSCredential",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "ItemType",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["Type"],
            },
            {
                name: "Name",
                type: "string",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Value",
                type: "object",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["Target"],
            },
        ],
    },
    {
        name: "New-ItemProperty",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Path",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Name",
                type: "string",
                mandatory: true,
                position: 1,
                helpMessage: null,
                aliases: ["PSProperty"],
            },
            {
                name: "Credential",
                type: "PSCredential",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Exclude",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Filter",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Include",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
            {
                name: "PropertyType",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["Type"],
            },
            {
                name: "Value",
                type: "object",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "New-Object",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "TypeName",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "ArgumentList",
                type: "object[]",
                mandatory: false,
                position: 1,
                helpMessage: null,
                aliases: ["Args"],
            },
            {
                name: "Property",
                type: "IDictionary",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Strict",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "New-PSDrive",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Name",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "PSProvider",
                type: "string",
                mandatory: true,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Root",
                type: "string",
                mandatory: true,
                position: 2,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Credential",
                type: "PSCredential",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Description",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Scope",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "New-TemporaryFile",
        description: null,
        outputType: "FileInfo",
        parameters: [
        ],
    },
    {
        name: "New-TimeSpan",
        description: null,
        outputType: "TimeSpan",
        parameters: [
            {
                name: "Start",
                type: "DateTime",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: ["LastWriteTime"],
            },
            {
                name: "End",
                type: "DateTime",
                mandatory: false,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Days",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Hours",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Milliseconds",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Minutes",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Seconds",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "New-Variable",
        description: null,
        outputType: "PSVariable",
        parameters: [
            {
                name: "Name",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Value",
                type: "object",
                mandatory: false,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Description",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Option",
                type: "ScopedItemOptions",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "PassThru",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Scope",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Visibility",
                type: "SessionStateEntryVisibility",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Out-File",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "FilePath",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: ["Path"],
            },
            {
                name: "Encoding",
                type: "Encoding",
                mandatory: false,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Append",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "InputObject",
                type: "object",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
            {
                name: "NoClobber",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["NoOverwrite"],
            },
            {
                name: "NoNewline",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Width",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Out-String",
        description: null,
        outputType: "string",
        parameters: [
            {
                name: "InputObject",
                type: "object",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "NoNewline",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Stream",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Width",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Pop-Location",
        description: null,
        outputType: "PathInfo",
        parameters: [
            {
                name: "PassThru",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "StackName",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Protect-CmsMessage",
        description: null,
        outputType: "string",
        parameters: [
            {
                name: "To",
                type: "CmsMessageRecipient[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Content",
                type: "object",
                mandatory: true,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string",
                mandatory: true,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Path",
                type: "string",
                mandatory: true,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "OutFile",
                type: "string",
                mandatory: false,
                position: 2,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Push-Location",
        description: null,
        outputType: "PathInfo",
        parameters: [
            {
                name: "Path",
                type: "string",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
            {
                name: "PassThru",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "StackName",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Read-Host",
        description: null,
        outputType: "string",
        parameters: [
            {
                name: "Prompt",
                type: "object",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "AsSecureString",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "MaskInput",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Register-EngineEvent",
        description: null,
        outputType: "PSEventJob",
        parameters: [
            {
                name: "SourceIdentifier",
                type: "string",
                mandatory: true,
                position: 100,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Action",
                type: "ScriptBlock",
                mandatory: false,
                position: 101,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Forward",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "MaxTriggerCount",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "MessageData",
                type: "object",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "SupportEvent",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Register-ObjectEvent",
        description: null,
        outputType: "PSEventJob",
        parameters: [
            {
                name: "InputObject",
                type: "object",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "EventName",
                type: "string",
                mandatory: true,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "SourceIdentifier",
                type: "string",
                mandatory: false,
                position: 100,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Action",
                type: "ScriptBlock",
                mandatory: false,
                position: 101,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Forward",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "MaxTriggerCount",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "MessageData",
                type: "object",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "SupportEvent",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Remove-Alias",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Name",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Scope",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Remove-Event",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "EventIdentifier",
                type: "int",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "SourceIdentifier",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Remove-Item",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Path",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Credential",
                type: "PSCredential",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Exclude",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Filter",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Include",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
            {
                name: "Recurse",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Remove-ItemProperty",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Path",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Name",
                type: "string[]",
                mandatory: true,
                position: 1,
                helpMessage: null,
                aliases: ["PSProperty"],
            },
            {
                name: "Credential",
                type: "PSCredential",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Exclude",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Filter",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Include",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
        ],
    },
    {
        name: "Remove-PSBreakpoint",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Breakpoint",
                type: "Breakpoint[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Id",
                type: "int[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Runspace",
                type: "Runspace",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["RunspaceId"],
            },
        ],
    },
    {
        name: "Remove-PSDrive",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "LiteralName",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Name",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "PSProvider",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Scope",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Remove-TypeData",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "TypeName",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Path",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "TypeData",
                type: "TypeData",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Remove-Variable",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Name",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Exclude",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Include",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Scope",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Rename-Item",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Path",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "NewName",
                type: "string",
                mandatory: true,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Credential",
                type: "PSCredential",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
            {
                name: "PassThru",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Rename-ItemProperty",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Path",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Name",
                type: "string",
                mandatory: true,
                position: 1,
                helpMessage: null,
                aliases: ["PSProperty"],
            },
            {
                name: "NewName",
                type: "string",
                mandatory: true,
                position: 2,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Credential",
                type: "PSCredential",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Exclude",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Filter",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Include",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
            {
                name: "PassThru",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Resolve-Path",
        description: null,
        outputType: "string",
        parameters: [
            {
                name: "Path",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Credential",
                type: "PSCredential",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
            {
                name: "Relative",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "RelativeBasePath",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Restart-Computer",
        description: null,
        outputType: null,
        parameters: [
        ],
    },
    {
        name: "Select-Object",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Property",
                type: "object[]",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "CaseInsensitive",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "ExcludeProperty",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "ExpandProperty",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "First",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Index",
                type: "int[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "InputObject",
                type: "object",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Last",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Skip",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "SkipIndex",
                type: "int[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "SkipLast",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Unique",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Wait",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Select-String",
        description: null,
        outputType: "bool",
        parameters: [
            {
                name: "Pattern",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Path",
                type: "string[]",
                mandatory: true,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "AllMatches",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "CaseSensitive",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Context",
                type: "int[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Culture",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Encoding",
                type: "Encoding",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Exclude",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Include",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "InputObject",
                type: "object",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "List",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
            {
                name: "NoEmphasis",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "NotMatch",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Quiet",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Raw",
                type: "SwitchParameter",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "SimpleMatch",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Select-Xml",
        description: null,
        outputType: "SelectXmlInfo",
        parameters: [
            {
                name: "XPath",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Path",
                type: "string[]",
                mandatory: true,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Xml",
                type: "XmlNode[]",
                mandatory: true,
                position: 1,
                helpMessage: null,
                aliases: ["Node"],
            },
            {
                name: "Content",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
            {
                name: "Namespace",
                type: "Hashtable",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Send-MailMessage",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "To",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Subject",
                type: "string",
                mandatory: false,
                position: 1,
                helpMessage: null,
                aliases: ["sub"],
            },
            {
                name: "Body",
                type: "string",
                mandatory: false,
                position: 2,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "SmtpServer",
                type: "string",
                mandatory: false,
                position: 3,
                helpMessage: null,
                aliases: ["ComputerName"],
            },
            {
                name: "Attachments",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["PsPath"],
            },
            {
                name: "Bcc",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "BodyAsHtml",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["BAH"],
            },
            {
                name: "Cc",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Credential",
                type: "PSCredential",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "DeliveryNotificationOption",
                type: "DeliveryNotificationOptions",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["DNO"],
            },
            {
                name: "Encoding",
                type: "Encoding",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["BE"],
            },
            {
                name: "From",
                type: "string",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Port",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Priority",
                type: "MailPriority",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "ReplyTo",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "UseSsl",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Set-Alias",
        description: null,
        outputType: "AliasInfo",
        parameters: [
            {
                name: "Name",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Value",
                type: "string",
                mandatory: true,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Description",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Option",
                type: "ScopedItemOptions",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "PassThru",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Scope",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Set-Clipboard",
        description: null,
        outputType: "string",
        parameters: [
            {
                name: "Value",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Append",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "AsOSC52",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["ToLocalhost"],
            },
            {
                name: "PassThru",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Set-Content",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Path",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Value",
                type: "object[]",
                mandatory: true,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "AsByteStream",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Credential",
                type: "PSCredential",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Encoding",
                type: "Encoding",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Exclude",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Filter",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Include",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
            {
                name: "NoNewline",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "PassThru",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Set-Date",
        description: null,
        outputType: "DateTime",
        parameters: [
            {
                name: "Adjust",
                type: "TimeSpan",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Date",
                type: "DateTime",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "DisplayHint",
                type: "DisplayHintType",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Set-ExecutionPolicy",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "ExecutionPolicy",
                type: "ExecutionPolicy",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Scope",
                type: "ExecutionPolicyScope",
                mandatory: false,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Set-Item",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Path",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Value",
                type: "object",
                mandatory: false,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Credential",
                type: "PSCredential",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Exclude",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Filter",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Include",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
            {
                name: "PassThru",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Set-ItemProperty",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Path",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Name",
                type: "string",
                mandatory: true,
                position: 1,
                helpMessage: null,
                aliases: ["PSProperty"],
            },
            {
                name: "Value",
                type: "object",
                mandatory: true,
                position: 2,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Credential",
                type: "PSCredential",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Exclude",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Filter",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Include",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "InputObject",
                type: "object",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
            {
                name: "PassThru",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Set-Location",
        description: null,
        outputType: "PathInfo",
        parameters: [
            {
                name: "Path",
                type: "string",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
            {
                name: "PassThru",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "StackName",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Set-MarkdownOption",
        description: null,
        outputType: "PSMarkdownOptionInfo",
        parameters: [
            {
                name: "InputObject",
                type: "object",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "BoldForegroundColor",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Code",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Header1Color",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Header2Color",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Header3Color",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Header4Color",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Header5Color",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Header6Color",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "ImageAltTextForegroundColor",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "ItalicsForegroundColor",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LinkForegroundColor",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "PassThru",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Theme",
                type: "string",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Set-PSBreakpoint",
        description: null,
        outputType: "CommandBreakpoint",
        parameters: [
            {
                name: "Script",
                type: "string[]",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Line",
                type: "int[]",
                mandatory: true,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Column",
                type: "int",
                mandatory: false,
                position: 2,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Action",
                type: "ScriptBlock",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Command",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["C"],
            },
            {
                name: "Mode",
                type: "VariableAccessMode",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Runspace",
                type: "Runspace",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Variable",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["V"],
            },
        ],
    },
    {
        name: "Set-TraceSource",
        description: null,
        outputType: "PSTraceSource",
        parameters: [
            {
                name: "Name",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Option",
                type: "PSTraceSourceOptions",
                mandatory: false,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Debugger",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "FilePath",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "Path"],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "ListenerOption",
                type: "TraceOptions",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "PSHost",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "PassThru",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "RemoveFileListener",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "RemoveListener",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Set-Variable",
        description: null,
        outputType: "PSVariable",
        parameters: [
            {
                name: "Name",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Value",
                type: "object",
                mandatory: false,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Append",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Description",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Exclude",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Include",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Option",
                type: "ScopedItemOptions",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "PassThru",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Scope",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Visibility",
                type: "SessionStateEntryVisibility",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Show-Markdown",
        description: null,
        outputType: "string",
        parameters: [
            {
                name: "Path",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "InputObject",
                type: "object",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
            {
                name: "UseBrowser",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Sort-Object",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Property",
                type: "object[]",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Bottom",
                type: "int",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "CaseSensitive",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Culture",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Descending",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "InputObject",
                type: "object",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Stable",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Top",
                type: "int",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Unique",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Split-Path",
        description: null,
        outputType: "string",
        parameters: [
            {
                name: "Path",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Credential",
                type: "PSCredential",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Extension",
                type: "SwitchParameter",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "IsAbsolute",
                type: "SwitchParameter",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Leaf",
                type: "SwitchParameter",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LeafBase",
                type: "SwitchParameter",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
            {
                name: "NoQualifier",
                type: "SwitchParameter",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Parent",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Qualifier",
                type: "SwitchParameter",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Resolve",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Start-Process",
        description: null,
        outputType: "Process",
        parameters: [
            {
                name: "FilePath",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: ["PSPath", "Path"],
            },
            {
                name: "ArgumentList",
                type: "string[]",
                mandatory: false,
                position: 1,
                helpMessage: null,
                aliases: ["Args"],
            },
            {
                name: "Credential",
                type: "PSCredential",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["RunAs"],
            },
            {
                name: "Environment",
                type: "Hashtable",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LoadUserProfile",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["Lup"],
            },
            {
                name: "NoNewWindow",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["nnw"],
            },
            {
                name: "PassThru",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "RedirectStandardError",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["RSE"],
            },
            {
                name: "RedirectStandardInput",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["RSI"],
            },
            {
                name: "RedirectStandardOutput",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["RSO"],
            },
            {
                name: "UseNewEnvironment",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Verb",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Wait",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "WindowStyle",
                type: "ProcessWindowStyle",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "WorkingDirectory",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Start-Sleep",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Duration",
                type: "TimeSpan",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: ["ts"],
            },
            {
                name: "Seconds",
                type: "double",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Milliseconds",
                type: "int",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["ms"],
            },
        ],
    },
    {
        name: "Stop-Computer",
        description: null,
        outputType: null,
        parameters: [
        ],
    },
    {
        name: "Stop-Process",
        description: null,
        outputType: "Process",
        parameters: [
            {
                name: "Id",
                type: "int[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "InputObject",
                type: "Process[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Name",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["ProcessName"],
            },
            {
                name: "PassThru",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Tee-Object",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "FilePath",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: ["Path"],
            },
            {
                name: "Append",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Encoding",
                type: "Encoding",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "InputObject",
                type: "object",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
            {
                name: "Variable",
                type: "string",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Test-Connection",
        description: null,
        outputType: "PingStatus",
        parameters: [
            {
                name: "TargetName",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: ["ComputerName"],
            },
            {
                name: "BufferSize",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["Size", "Bytes", "BS"],
            },
            {
                name: "Count",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Delay",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Detailed",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "DontFragment",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "IPv4",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "IPv6",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "MaxHops",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["Ttl", "TimeToLive", "Hops"],
            },
            {
                name: "MtuSize",
                type: "SwitchParameter",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["MtuSizeDetect"],
            },
            {
                name: "Ping",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Quiet",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Repeat",
                type: "SwitchParameter",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["Continuous"],
            },
            {
                name: "ResolveDestination",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Source",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "TcpPort",
                type: "int",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "TimeoutSeconds",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Traceroute",
                type: "SwitchParameter",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Test-Json",
        description: null,
        outputType: "bool",
        parameters: [
            {
                name: "Json",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
            {
                name: "Path",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Schema",
                type: "string",
                mandatory: true,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "SchemaFile",
                type: "string",
                mandatory: true,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Options",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Test-Path",
        description: null,
        outputType: "bool",
        parameters: [
            {
                name: "Path",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Credential",
                type: "PSCredential",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Exclude",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Filter",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Include",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "IsValid",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
            {
                name: "NewerThan",
                type: "Nullable\u00601",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "OlderThan",
                type: "Nullable\u00601",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "PathType",
                type: "TestPathType",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["Type"],
            },
        ],
    },
    {
        name: "Trace-Command",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Name",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Command",
                type: "string",
                mandatory: true,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Expression",
                type: "ScriptBlock",
                mandatory: true,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Option",
                type: "PSTraceSourceOptions",
                mandatory: false,
                position: 2,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "ArgumentList",
                type: "object[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["Args"],
            },
            {
                name: "Debugger",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "FilePath",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "Path"],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "InputObject",
                type: "object",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "ListenerOption",
                type: "TraceOptions",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "PSHost",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Unblock-File",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Path",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: ["PSPath", "LP"],
            },
        ],
    },
    {
        name: "Unprotect-CmsMessage",
        description: null,
        outputType: "string",
        parameters: [
            {
                name: "Content",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "EventLogRecord",
                type: "object",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "LiteralPath",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Path",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "To",
                type: "CmsMessageRecipient[]",
                mandatory: false,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "IncludeContext",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Unregister-Event",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "SourceIdentifier",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "SubscriptionId",
                type: "int",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Update-FormatData",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "AppendPath",
                type: "string[]",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: ["PSPath", "Path"],
            },
            {
                name: "PrependPath",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Update-List",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Property",
                type: "string",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Add",
                type: "object[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "InputObject",
                type: "object",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Remove",
                type: "object[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Replace",
                type: "object[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Update-TypeData",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "AppendPath",
                type: "string[]",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: ["PSPath", "Path"],
            },
            {
                name: "TypeData",
                type: "TypeData[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "DefaultDisplayProperty",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "DefaultDisplayPropertySet",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "DefaultKeyPropertySet",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Force",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "InheritPropertySerializationSet",
                type: "Nullable\u00601",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "MemberName",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "MemberType",
                type: "PSMemberTypes",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "PrependPath",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "PropertySerializationSet",
                type: "string[]",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "SecondValue",
                type: "object",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "SerializationDepth",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "SerializationMethod",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "StringSerializationSource",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "TargetTypeForDeserialization",
                type: "Type",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "TypeAdapter",
                type: "Type",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "TypeConverter",
                type: "Type",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "TypeName",
                type: "string",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Value",
                type: "object",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Wait-Debugger",
        description: null,
        outputType: null,
        parameters: [
        ],
    },
    {
        name: "Wait-Event",
        description: null,
        outputType: "PSEventArgs",
        parameters: [
            {
                name: "SourceIdentifier",
                type: "string",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Timeout",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["TimeoutSec"],
            },
        ],
    },
    {
        name: "Wait-Process",
        description: null,
        outputType: "Process",
        parameters: [
            {
                name: "Id",
                type: "int[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: ["PID", "ProcessId"],
            },
            {
                name: "Name",
                type: "string[]",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: ["ProcessName"],
            },
            {
                name: "Timeout",
                type: "int",
                mandatory: false,
                position: 1,
                helpMessage: null,
                aliases: ["TimeoutSec"],
            },
            {
                name: "Any",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "InputObject",
                type: "Process[]",
                mandatory: true,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "PassThru",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Write-Debug",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Message",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: ["Msg"],
            },
        ],
    },
    {
        name: "Write-Error",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "ErrorRecord",
                type: "ErrorRecord",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Exception",
                type: "Exception",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Message",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: ["Msg"],
            },
            {
                name: "Category",
                type: "ErrorCategory",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "CategoryActivity",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["Activity"],
            },
            {
                name: "CategoryReason",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["Reason"],
            },
            {
                name: "CategoryTargetName",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["TargetName"],
            },
            {
                name: "CategoryTargetType",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: ["TargetType"],
            },
            {
                name: "ErrorId",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "RecommendedAction",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "TargetObject",
                type: "object",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Write-Host",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Object",
                type: "object",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: ["Msg", "Message"],
            },
            {
                name: "BackgroundColor",
                type: "ConsoleColor",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "ForegroundColor",
                type: "ConsoleColor",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "NoNewline",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Separator",
                type: "object",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Write-Information",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "MessageData",
                type: "object",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: ["Msg", "Message"],
            },
            {
                name: "Tags",
                type: "string[]",
                mandatory: false,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Write-Output",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "InputObject",
                type: "object",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "NoEnumerate",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Write-Progress",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Activity",
                type: "string",
                mandatory: false,
                position: 0,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Status",
                type: "string",
                mandatory: false,
                position: 1,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Id",
                type: "int",
                mandatory: false,
                position: 2,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "Completed",
                type: "SwitchParameter",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "CurrentOperation",
                type: "string",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "ParentId",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "PercentComplete",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "SecondsRemaining",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
            {
                name: "SourceId",
                type: "int",
                mandatory: false,
                position: null,
                helpMessage: null,
                aliases: [],
            },
        ],
    },
    {
        name: "Write-Verbose",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Message",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: ["Msg"],
            },
        ],
    },
    {
        name: "Write-Warning",
        description: null,
        outputType: null,
        parameters: [
            {
                name: "Message",
                type: "string",
                mandatory: true,
                position: 0,
                helpMessage: null,
                aliases: ["Msg"],
            },
        ],
    },
];

export interface TypeProperty {
    name: string;
    type: string;
}

export interface TypeDefinition {
    name: string;
    properties: TypeProperty[];
}

export const variableTypes: TypeDefinition[] = [
    {
        name: "Game",
        properties: [
            {
                name: "Actions",
                type: "Action[]",
            },
            {
                name: "Archives",
                type: "Archive[]",
            },
            {
                name: "BaseGameId",
                type: "Guid",
            },
            {
                name: "Collections",
                type: "Collection[]",
            },
            {
                name: "CreatedOn",
                type: "DateTime",
            },
            {
                name: "CustomFields",
                type: "GameCustomField[]",
            },
            {
                name: "DependentGames",
                type: "Guid[]",
            },
            {
                name: "Description",
                type: "string",
            },
            {
                name: "Developers",
                type: "Company[]",
            },
            {
                name: "DirectoryName",
                type: "string",
            },
            {
                name: "Engine",
                type: "Engine",
            },
            {
                name: "ExternalIds",
                type: "GameExternalId[]",
            },
            {
                name: "Genres",
                type: "Genre[]",
            },
            {
                name: "Id",
                type: "Guid",
            },
            {
                name: "InLibrary",
                type: "bool",
            },
            {
                name: "InstallDirectory",
                type: "string",
            },
            {
                name: "IsAddon",
                type: "bool",
            },
            {
                name: "Keys",
                type: "Key[]",
            },
            {
                name: "Media",
                type: "Media[]",
            },
            {
                name: "MultiplayerModes",
                type: "MultiplayerMode[]",
            },
            {
                name: "Notes",
                type: "string",
            },
            {
                name: "Platforms",
                type: "Platform[]",
            },
            {
                name: "PlaySessions",
                type: "PlaySession[]",
            },
            {
                name: "Publishers",
                type: "Company[]",
            },
            {
                name: "Redistributables",
                type: "Redistributable[]",
            },
            {
                name: "ReleasedOn",
                type: "DateTime",
            },
            {
                name: "SavePaths",
                type: "SavePath[]",
            },
            {
                name: "Saves",
                type: "Save[]",
            },
            {
                name: "Scripts",
                type: "Script[]",
            },
            {
                name: "Servers",
                type: "Server[]",
            },
            {
                name: "Singleplayer",
                type: "bool",
            },
            {
                name: "SortTitle",
                type: "string",
            },
            {
                name: "Tags",
                type: "Tag[]",
            },
            {
                name: "Title",
                type: "string",
            },
            {
                name: "Tools",
                type: "Tool[]",
            },
            {
                name: "Type",
                type: "GameType",
            },
            {
                name: "UpdatedOn",
                type: "DateTime",
            },
        ],
    },
    {
        name: "GameManifest",
        properties: [
            {
                name: "Actions",
                type: "Action[]",
            },
            {
                name: "Addons",
                type: "Game[]",
            },
            {
                name: "Archives",
                type: "Archive[]",
            },
            {
                name: "BaseGame",
                type: "string",
            },
            {
                name: "BaseGameId",
                type: "Guid",
            },
            {
                name: "Collections",
                type: "Collection[]",
            },
            {
                name: "CreatedBy",
                type: "string",
            },
            {
                name: "CreatedOn",
                type: "DateTime",
            },
            {
                name: "CustomFields",
                type: "GameCustomField[]",
            },
            {
                name: "Description",
                type: "string",
            },
            {
                name: "Developers",
                type: "Company[]",
            },
            {
                name: "DirectoryName",
                type: "string",
            },
            {
                name: "Engine",
                type: "Engine",
            },
            {
                name: "ExternalIds",
                type: "GameExternalId[]",
            },
            {
                name: "Genres",
                type: "Genre[]",
            },
            {
                name: "Id",
                type: "Guid",
            },
            {
                name: "InstallDirectory",
                type: "string",
            },
            {
                name: "IsAddon",
                type: "bool",
            },
            {
                name: "Keys",
                type: "Key[]",
            },
            {
                name: "ManifestVersion",
                type: "string",
            },
            {
                name: "Media",
                type: "Media[]",
            },
            {
                name: "MultiplayerModes",
                type: "MultiplayerMode[]",
            },
            {
                name: "Notes",
                type: "string",
            },
            {
                name: "Platforms",
                type: "Platform[]",
            },
            {
                name: "PlaySessions",
                type: "PlaySession[]",
            },
            {
                name: "Publishers",
                type: "Company[]",
            },
            {
                name: "Redistributables",
                type: "Redistributable[]",
            },
            {
                name: "ReleasedOn",
                type: "DateTime",
            },
            {
                name: "SavePaths",
                type: "SavePath[]",
            },
            {
                name: "Saves",
                type: "Save[]",
            },
            {
                name: "Scripts",
                type: "Script[]",
            },
            {
                name: "Singleplayer",
                type: "bool",
            },
            {
                name: "SortTitle",
                type: "string",
            },
            {
                name: "Tags",
                type: "Tag[]",
            },
            {
                name: "Title",
                type: "string",
            },
            {
                name: "Tools",
                type: "Tool[]",
            },
            {
                name: "Type",
                type: "GameType",
            },
            {
                name: "UpdatedBy",
                type: "string",
            },
            {
                name: "UpdatedOn",
                type: "DateTime",
            },
            {
                name: "Version",
                type: "string",
            },
        ],
    },
    {
        name: "Redistributable",
        properties: [
            {
                name: "Archives",
                type: "Archive[]",
            },
            {
                name: "CreatedOn",
                type: "DateTime",
            },
            {
                name: "Description",
                type: "string",
            },
            {
                name: "Id",
                type: "Guid",
            },
            {
                name: "Name",
                type: "string",
            },
            {
                name: "Notes",
                type: "string",
            },
            {
                name: "OptionSchema",
                type: "string",
            },
            {
                name: "ReleasedOn",
                type: "DateTime",
            },
            {
                name: "Scripts",
                type: "Script[]",
            },
            {
                name: "UpdatedOn",
                type: "DateTime",
            },
            {
                name: "Version",
                type: "string",
            },
        ],
    },
    {
        name: "RedistributableManifest",
        properties: [
            {
                name: "Archives",
                type: "Archive[]",
            },
            {
                name: "CreatedBy",
                type: "string",
            },
            {
                name: "CreatedOn",
                type: "DateTime",
            },
            {
                name: "Description",
                type: "string",
            },
            {
                name: "Id",
                type: "Guid",
            },
            {
                name: "ManifestVersion",
                type: "string",
            },
            {
                name: "Name",
                type: "string",
            },
            {
                name: "Notes",
                type: "string",
            },
            {
                name: "Options",
                type: "KeyValuePair\u00602[]",
            },
            {
                name: "OptionSchema",
                type: "string",
            },
            {
                name: "ReleasedOn",
                type: "DateTime",
            },
            {
                name: "Scripts",
                type: "Script[]",
            },
            {
                name: "UpdatedBy",
                type: "string",
            },
            {
                name: "UpdatedOn",
                type: "DateTime",
            },
            {
                name: "Version",
                type: "string",
            },
        ],
    },
    {
        name: "Server",
        properties: [
            {
                name: "Actions",
                type: "Action[]",
            },
            {
                name: "Arguments",
                type: "string",
            },
            {
                name: "Autostart",
                type: "bool",
            },
            {
                name: "AutostartDelay",
                type: "int",
            },
            {
                name: "AutostartMethod",
                type: "ServerAutostartMethod",
            },
            {
                name: "CreatedOn",
                type: "DateTime",
            },
            {
                name: "Game",
                type: "Game",
            },
            {
                name: "Host",
                type: "string",
            },
            {
                name: "HttpPaths",
                type: "ServerHttpPath[]",
            },
            {
                name: "Id",
                type: "Guid",
            },
            {
                name: "Name",
                type: "string",
            },
            {
                name: "OnStartScriptPath",
                type: "string",
            },
            {
                name: "OnStopScriptPath",
                type: "string",
            },
            {
                name: "Path",
                type: "string",
            },
            {
                name: "Port",
                type: "int",
            },
            {
                name: "ProcessTerminationMethod",
                type: "ProcessTerminationMethod",
            },
            {
                name: "Scripts",
                type: "Script[]",
            },
            {
                name: "ServerConsoles",
                type: "ServerConsole[]",
            },
            {
                name: "UpdatedOn",
                type: "DateTime",
            },
            {
                name: "UseShellExecute",
                type: "bool",
            },
            {
                name: "WorkingDirectory",
                type: "string",
            },
        ],
    },
    {
        name: "Tool",
        properties: [
            {
                name: "AlwaysInstall",
                type: "bool",
            },
            {
                name: "Archives",
                type: "Archive[]",
            },
            {
                name: "CreatedOn",
                type: "DateTime",
            },
            {
                name: "Description",
                type: "string",
            },
            {
                name: "Id",
                type: "Guid",
            },
            {
                name: "Name",
                type: "string",
            },
            {
                name: "Notes",
                type: "string",
            },
            {
                name: "ReleasedOn",
                type: "DateTime",
            },
            {
                name: "Scripts",
                type: "Script[]",
            },
            {
                name: "UpdatedOn",
                type: "DateTime",
            },
        ],
    },
    {
        name: "ToolManifest",
        properties: [
            {
                name: "Actions",
                type: "Action[]",
            },
            {
                name: "Archives",
                type: "Archive[]",
            },
            {
                name: "CreatedBy",
                type: "string",
            },
            {
                name: "CreatedOn",
                type: "DateTime",
            },
            {
                name: "Description",
                type: "string",
            },
            {
                name: "Games",
                type: "Game[]",
            },
            {
                name: "Id",
                type: "Guid",
            },
            {
                name: "ManifestVersion",
                type: "string",
            },
            {
                name: "Name",
                type: "string",
            },
            {
                name: "Notes",
                type: "string",
            },
            {
                name: "ReleasedOn",
                type: "DateTime",
            },
            {
                name: "Scripts",
                type: "Script[]",
            },
            {
                name: "UpdatedBy",
                type: "string",
            },
            {
                name: "UpdatedOn",
                type: "DateTime",
            },
        ],
    },
    {
        name: "User",
        properties: [
            {
                name: "Alias",
                type: "string",
            },
            {
                name: "Id",
                type: "Guid",
            },
            {
                name: "Name",
                type: "string",
            },
            {
                name: "UserName",
                type: "string",
            },
        ],
    },
];

export const scriptTypeValues: string[] = [
    "Install",
    "Uninstall",
    "NameChange",
    "KeyChange",
    "SaveUpload",
    "SaveDownload",
    "DetectInstall",
    "BeforeStart",
    "AfterStop",
    "GameStarted",
    "GameStopped",
    "UserRegistration",
    "UserLogin",
    "ApplicationStart",
    "Package",
    "RunWrapper",
];
